export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_01.5ef0eb16.jpg";